export default __webpack_public_path__ + "static/media/AF.0131a497.svg";